import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import SocialNetworksPage from '../pages/SocialNetworksPage';
import CalendarPage from '../pages/CalendarPage';
import ReviewsPage from '../pages/ReviewsPage';
import IntelligencePage from '../pages/IntelligencePage';
import ProspectsPage from '../pages/ProspectsPage';
import InboxPage from '../pages/InboxPage';
import CadastrePage from '../pages/CadastrePage';
import EstimationPage from '../pages/EstimationPage';
import VentesPage from '../pages/VentesPage';
import NotificationsPage from '../pages/NotificationsPage';
import BilanPage from '../pages/BilanPage';
import ParrainagePage from '../pages/ParrainagePage';
import FicheGooglePage from '../pages/FicheGooglePage';
import VideosPage from '../pages/VideosPage';
// SecretaryPage / MailAgentPage : en stand-by (voir plus bas), imports retirés.
import ObjectivesSelector from './ObjectivesSelector';
import AnalyticsDashboard from './AnalyticsDashboard';
import OnboardingWizard from './OnboardingWizard';
import BillingSection from './BillingSection';
import CreatePostModal from './CreatePostModal';

// ── SVG Icons ────────────────────────────────────────────────────────────────
const Icon = {
  Bell: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 10-12 0v3.2c0 .5-.2 1-.6 1.4L4 17h5m6 0a3 3 0 11-6 0m6 0H9" />
    </svg>
  ),
  Gift: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H8a2 2 0 110-4c2.5 0 4 4 4 4zm0 0h4a2 2 0 100-4c-2.5 0-4 4-4 4z" />
    </svg>
  ),
  Home: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7m-9 2v8m4-8v8m5-8l2 2" />
    </svg>
  ),
  Share: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
    </svg>
  ),
  Sparkles: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456z" />
    </svg>
  ),
  Calendar: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/>
      <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  ),
  Chart: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
    </svg>
  ),
  User: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
    </svg>
  ),
  Logout: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
    </svg>
  ),
  Rocket: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-5 h-5 shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
    </svg>
  ),
  Search: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  ),
  Plus: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} className="w-4 h-4 shrink-0">
      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  ),
  Settings: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <circle cx="12" cy="12" r="3"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
    </svg>
  ),
  Star: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
    </svg>
  ),
  Radar: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
    </svg>
  ),
  Inbox: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"/>
    </svg>
  ),
  Target: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none"/>
    </svg>
  ),
  Mic: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 15a3 3 0 003-3V6a3 3 0 10-6 0v6a3 3 0 003 3z"/>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 11a7 7 0 01-14 0M12 18v3"/>
    </svg>
  ),
  Map: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 3v15l-6 3V6l6-3zm0 0l6 3m0 0l6-3v15l-6 3m0-15v15m0-15l-6-3" />
    </svg>
  ),
  Mail: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 6h18v12H3V6zm0 0l9 7 9-7" />
    </svg>
  ),
  Coins: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <ellipse cx="9" cy="7" rx="6" ry="2.5" /><path d="M3 7v4c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5V7" />
      <path d="M9 13.5v4c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5v-4c0-1.4-2.7-2.5-6-2.5" />
    </svg>
  ),
  Tag: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-[18px] h-[18px] shrink-0">
      <path strokeLinecap="round" strokeLinejoin="round" d="M20.59 13.41L11 3.83A2 2 0 009.59 3.24L4 3a1 1 0 00-1 1l.24 5.59a2 2 0 00.59 1.41l9.58 9.58a2 2 0 002.83 0l4.35-4.35a2 2 0 000-2.82z" />
      <circle cx="7.5" cy="7.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  ),
};

// ── Détection des professionnels de l'immobilier ─────────────────────────────
// Cadastre et Estimation n'ont de sens que pour ce métier : agences, mandataires,
// négociateurs, réseaux (SAFTI, IAD, Capifrance...). Masqués pour tous les autres.

// Métier déclaré (champ Activité, ou à défaut le nom de l'entreprise)
const REAL_ESTATE_ACTIVITY =
  /(immobili|agent\s*immo|n[ée]gociateur|mandataire|transaction\s*immo|marchand\s*de\s*biens|syndic|g[ée]rance\s*locative|viager|lotisseur|promoteur)/i;

// Nom de domaine : réseaux connus + jetons génériques.
// Les délimiteurs évitent les faux positifs ("iad" ne doit pas matcher "mediad.fr").
const REAL_ESTATE_DOMAIN =
  // Un suffixe accolé est toléré : bskimmobilier.com et iadfrance.fr collent
  // deux mots sans séparateur, et sans cette tolérance ni les conseillers BSK
  // ni ceux d'IAD n'étaient reconnus comme professionnels de l'immobilier.
  /(^|[.\-])(safti|iad|capifrance|optimhome|megagence|mega-agence|dr-?house|laforet|century-?21|orpi|guy-?hoquet|stephane-?plaza|bsk|proprietes-privees|efficity|3g-immo|welmo|immo|immobilier)(immobilier|france|immo)?([.\-]|$)/i;

function isRealEstatePro(user: any): boolean {
  if (REAL_ESTATE_ACTIVITY.test(String(user?.activite || ''))) return true;
  if (REAL_ESTATE_ACTIVITY.test(String(user?.nom_entreprise || ''))) return true;

  // On ne teste que le nom de domaine, pas le chemin de l'URL
  const host = String(user?.site_web || '')
    .toLowerCase()
    .trim()
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .split('/')[0];

  return !!host && REAL_ESTATE_DOMAIN.test(host);
}

// ── Nav structure (sections + items) ─────────────────────────────────────────
// L'onglet "Prospects" (DPE ADEME) n'est pertinent que pour les agents SAFTI
// (biens détectés avant mise en vente sur le secteur de l'agent).
function getNavSections(isSafti: boolean, isImmo: boolean) {
  return [
    {
      label: 'GÉRER',
      items: [
        { id: 'overview',  label: 'Vue d\'ensemble', Icon: Icon.Home },
        { id: 'social',    label: 'Réseaux sociaux', Icon: Icon.Share },
        { id: 'calendar',  label: 'Calendrier',       Icon: Icon.Calendar },
        { id: 'videos',    label: 'Vidéos',           Icon: Icon.Sparkles },
        { id: 'reviews',   label: 'Avis Google',      Icon: Icon.Star },
        { id: 'fiche-google', label: 'Fiche Google',  Icon: Icon.Search },
        { id: 'inbox',     label: 'Messages',         Icon: Icon.Inbox },
        { id: 'notifications', label: 'Notifications', Icon: Icon.Bell },
        // Secrétaire IA et Agent Mail IA : mis en stand-by (temporairement
        // retirés du menu et inaccessibles), à réactiver plus tard.
      ],
    },
    {
      label: 'ANALYSER',
      items: [
        { id: 'bilan',         label: 'Mon bilan',            Icon: Icon.Chart },
        { id: 'intelligence',  label: 'Veille & Concurrence', Icon: Icon.Radar },
        ...(isImmo ? [
          { id: 'cadastre',   label: 'Cadastre',   Icon: Icon.Map },
          { id: 'estimation', label: 'Estimation', Icon: Icon.Tag },
          { id: 'ventes',     label: 'Ventes',     Icon: Icon.Coins },
        ] : []),
        // Les prospects viennent des DPE de l'ADEME : ils concernent tout
        // professionnel de l'immobilier, pas seulement SAFTI.
        ...(isImmo ? [{ id: 'prospects', label: 'Prospects', Icon: Icon.Target }] : []),
      ],
    },
  ];
}

const bottomItems = [
  { id: 'parrainage', label: 'Parrainage', Icon: Icon.Gift },
  { id: 'profile', label: 'Mon compte', Icon: Icon.User },
];

// ── Page titles ───────────────────────────────────────────────────────────────
const pageTitles: Record<string, string> = {
  overview:  'Vue d\'ensemble',
  social:    'Réseaux sociaux',
  content:   'Contenu IA',
  calendar:  'Calendrier',
  reviews:       'Demander des avis Google',
  inbox:         'Messages',
  secretary:     'Secrétaire IA',
  mailagent:     'Agent Mail IA',
  intelligence:  'Veille & Concurrence',
  cadastre:      'Cadastre',
  estimation:    'Estimation',
  ventes:        'Ventes autour d\'une adresse',
  prospects:     'Prospects',
  notifications: 'Notifications',
  bilan:         'Mon bilan',
  parrainage:    'Parrainage',
  'fiche-google': 'Fiche Google',
  videos:        'Vidéos de visite',
  profile:   'Mon compte',
};

// ── Dashboard ─────────────────────────────────────────────────────────────────
const Dashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showCreatePost, setShowCreatePost] = useState(false);
  const [analyzingWebsite, setAnalyzingWebsite] = useState(false);
  const [analyzeMsg, setAnalyzeMsg] = useState<string | null>(null);
  const [descriptionActivite, setDescriptionActivite] = useState<string | null>(null);
  const [objectivesData, setObjectivesData] = useState<{ objectives: string[]; custom_angles: string[] }>({ objectives: [], custom_angles: [] });
  const [loadingObjectives, setLoadingObjectives] = useState(true);
  const [billingLoading, setBillingLoading] = useState(false);
  const [paymentMsg, setPaymentMsg] = useState<string | null>(null);
  // Fenetre de bienvenue : quel store proposer (voir plus bas).
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const estIos = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && 'ontouchend' in document);
  const estMobile = estIos || /Android/i.test(ua);
  const urlStore = estIos
    ? 'https://apps.apple.com/fr/app/evoclick/id6807842606'
    : 'https://play.google.com/store/apps/details?id=com.evoclick.evoclick_app&hl=fr';
  const [profileTab, setProfileTab] = useState<'profil' | 'abonnement'>('profil');

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    fetch('/api/objectives', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : { objectives: [], custom_angles: [] })
      .then(data => { setObjectivesData(data); setLoadingObjectives(false); })
      .catch(() => setLoadingObjectives(false));
  }, []);

  const saveObjectives = async (newData: { objectives: string[]; custom_angles: string[] }) => {
    setObjectivesData(newData);
    const token = localStorage.getItem('authToken');
    await fetch('/api/objectives', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(newData),
    });
  };

  const handleAnalyzeWebsite = async () => {
    setAnalyzingWebsite(true);
    setAnalyzeMsg(null);
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch('/api/auth/analyze-website', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Erreur analyse');
      setDescriptionActivite(data.description_activite);
      setAnalyzeMsg('✅ Analyse terminée ! Les prochains posts utiliseront ce profil enrichi.');
    } catch (err: any) {
      setAnalyzeMsg(`❌ ${err.message}`);
    } finally {
      setAnalyzingWebsite(false);
    }
  };

  // Vérifier les params URL après retour Stripe
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('payment') === 'success') {
      setPaymentMsg('success');
      window.history.replaceState({}, '', '/');
    } else if (params.get('payment') === 'cancel') {
      setPaymentMsg('cancel');
      window.history.replaceState({}, '', '/');
    }
  }, []);

  const handleSubscribe = async () => {
    setBillingLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch('/api/billing/create-checkout', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Erreur');
      window.location.href = data.url;
    } catch (err: any) {
      alert(err.message);
      setBillingLoading(false);
    }
  };

  const handleManageBilling = async () => {
    setBillingLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch('/api/billing/portal', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Erreur');
      window.location.href = data.url;
    } catch (err: any) {
      alert(err.message);
      setBillingLoading(false);
    }
  };

  const initials = (user?.username || '?').split(' ').map((w: string) => w[0]).join('').substring(0, 2).toUpperCase();
  const isSafti = !!user?.site_web?.toLowerCase().includes('safti');
  const isImmo  = isRealEstatePro(user);
  const navSections = getNavSections(isSafti, isImmo);

  // Render a nav item (used in sidebar sections + bottom)
  const NavItem = ({ id, label, NavIcon }: { id: string; label: string; NavIcon: React.FC }) => (
    <button
      key={id}
      onClick={() => { setActiveTab(id); setSidebarOpen(false); }}
      className={`group flex items-center gap-3 w-full px-3 py-2 rounded-lg transition-all duration-150 text-left ${
        activeTab === id
          ? 'bg-white/15 text-white'
          : 'text-white/50 hover:bg-white/8 hover:text-white/85'
      }`}
    >
      {activeTab === id && (
        <span className="absolute left-0 w-[3px] h-7 bg-violet-400 rounded-r-full" />
      )}
      <NavIcon />
      <span className="text-[13px] font-medium leading-none">{label}</span>
    </button>
  );

  if (user?.subscription_status === 'inactive') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center">
          <div className="text-5xl mb-4">⏱️</div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Votre période d'essai est terminée</h2>
          <p className="text-gray-500 text-sm mb-6">Pour continuer à utiliser Evoclick et maintenir la publication automatique sur vos réseaux, activez votre abonnement.</p>
          <a
            href="mailto:contact@evoclick.fr?subject=Activation abonnement"
            className="inline-block w-full py-3 bg-gradient-to-r from-violet-600 to-indigo-600 text-white text-sm font-semibold rounded-xl hover:from-violet-700 hover:to-indigo-700 transition-all shadow-md"
          >
            Activer mon abonnement →
          </a>
          <p className="text-xs text-gray-400 mt-4">Des questions ? contact@evoclick.fr</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-[#f4f5f7] overflow-hidden">
      {!user?.onboarding_completed && <OnboardingWizard />}

      {/* ── Overlay mobile (ferme sidebar au tap en dehors) ── */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/50 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Modal bienvenue après paiement Stripe réussi */}
      {paymentMsg === 'success' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden text-center">
            <div className="bg-gradient-to-r from-emerald-500 to-teal-500 px-8 py-8 text-white">
              <div className="text-6xl mb-3">🎉</div>
              <h2 className="text-2xl font-bold">Bienvenue sur Evoclick !</h2>
              <p className="text-white/85 text-sm mt-1">Votre essai gratuit de 30 jours est activé.</p>
            </div>
            {/* L'inscription se fait sur le web (abonnement Stripe, sans
                commission des stores) ; la suite se passe dans l'app. Cette
                fenetre est le pont : sans elle, le conseiller restait sur le
                tableau de bord web et ne savait pas qu'une app existait. */}
            <div className="px-8 py-6">
              <p className="text-gray-800 font-semibold mb-1">Étape suivante : installez l'app EvoClick</p>
              <p className="text-gray-500 text-sm mb-5">
                Connectez-vous avec le même compte : <strong className="text-gray-700">{user?.email}</strong>.
              </p>

              {estMobile ? (
                <a href={urlStore}
                  className="block w-full py-3.5 bg-gradient-to-r from-violet-600 to-indigo-600 text-white font-semibold rounded-xl shadow-md text-base">
                  {estIos ? 'Télécharger sur l\'App Store' : 'Télécharger sur Google Play'}
                </a>
              ) : (
                <div className="flex flex-col items-center gap-3">
                  <img src={`https://api.qrserver.com/v1/create-qr-code/?size=180x180&margin=8&data=${encodeURIComponent(`${window.location.origin}/api/app`)}`}
                    width={180} height={180} alt="QR code pour télécharger l'app EvoClick"
                    className="rounded-xl border border-gray-200" />
                  <p className="text-xs text-gray-500">Scannez avec l'appareil photo de votre téléphone</p>
                  <div className="flex gap-2 text-sm">
                    <a href="https://apps.apple.com/fr/app/evoclick/id6807842606" target="_blank" rel="noreferrer"
                      className="px-3 py-2 rounded-lg bg-gray-900 text-white font-medium">App Store</a>
                    <a href="https://play.google.com/store/apps/details?id=com.evoclick.evoclick_app&hl=fr" target="_blank" rel="noreferrer"
                      className="px-3 py-2 rounded-lg bg-violet-600 text-white font-medium">Google Play</a>
                  </div>
                </div>
              )}

              <button
                onClick={() => { setPaymentMsg(null); setActiveTab('social'); }}
                className="mt-5 w-full py-2.5 border border-gray-200 text-gray-700 font-medium rounded-xl hover:bg-gray-50 transition-all text-sm"
              >
                Continuer sur le web : connecter mes réseaux
              </button>
              <button onClick={() => setPaymentMsg(null)} className="mt-3 text-xs text-gray-400 hover:text-gray-500">
                Accéder au tableau de bord
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Sidebar ── */}
      <aside className={`
        fixed md:relative inset-y-0 left-0 z-40
        flex flex-col w-[220px] bg-[#1a1d2e] shrink-0
        transition-transform duration-300 ease-in-out
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
      `}>

        {/* Logo + brand */}
        <div className="flex items-center gap-3 px-4 h-16 border-b border-white/8">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center text-white shadow-md shrink-0">
            <Icon.Rocket />
          </div>
          <div className="leading-tight">
            <span className="text-white font-bold text-[15px] tracking-tight">Evoclick</span>
            <p className="text-white/40 text-[10px] uppercase tracking-widest">Manager</p>
          </div>
        </div>

        {/* CTA : Créer un post */}
        <div className="px-3 py-3 border-b border-white/8">
          <button
            onClick={() => { setShowCreatePost(true); setSidebarOpen(false); }}
            className="flex items-center justify-center gap-2 w-full py-2 rounded-lg bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-500 hover:to-indigo-500 text-white text-[13px] font-semibold shadow transition-all"
          >
            <Icon.Plus />
            Créer un post
          </button>
        </div>

        {/* Nav sections */}
        <nav className="flex-1 overflow-y-auto py-3 px-2 space-y-4">
          {navSections.map(section => (
            <div key={section.label}>
              <p className="text-white/25 text-[10px] font-semibold tracking-widest uppercase px-3 mb-1">
                {section.label}
              </p>
              <div className="space-y-0.5">
                {section.items.map(({ id, label, Icon: NavIcon }) => (
                  <NavItem key={id} id={id} label={label} NavIcon={NavIcon} />
                ))}
              </div>
            </div>
          ))}
        </nav>

        {/* Bottom nav + user */}
        <div className="border-t border-white/8 px-2 py-2 space-y-0.5">
          {bottomItems.map(({ id, label, Icon: NavIcon }) => (
            <NavItem key={id} id={id} label={label} NavIcon={NavIcon} />
          ))}
        </div>

        {/* User block */}
        <div className="flex items-center gap-3 px-4 py-3 border-t border-white/8">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-emerald-400 to-teal-500 flex items-center justify-center text-white text-xs font-bold shadow shrink-0">
            {initials}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-white text-[12px] font-medium truncate">{user?.username}</p>
            <p className="text-white/35 text-[10px] capitalize truncate">{user?.subscription_tier || 'Starter'}</p>
          </div>
          <button
            onClick={logout}
            title="Déconnexion"
            className="text-white/30 hover:text-white/70 transition-colors p-1"
          >
            <Icon.Logout />
          </button>
        </div>
      </aside>

      {/* ── Main ── */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">

        {/* ── Paywall : accès bloqué si pas abonné ── */}
        {user?.subscription_status === 'trial' && (
          <div className="absolute inset-0 z-40 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
              <div className="bg-gradient-to-r from-violet-600 to-indigo-600 px-8 py-8 text-white text-center">
                <div className="text-5xl mb-3">🚀</div>
                <h2 className="text-2xl font-bold">Commencez à booster votre Facebook, Instagram, Google&nbsp;&amp;&nbsp;LinkedIn</h2>
                <p className="text-white/80 text-sm mt-1">30 jours gratuits pour tester toutes les fonctionnalités.</p>
              </div>
              <div className="px-8 py-6">
                <div className="space-y-2.5 mb-6">
                  {[
                    { icon: '📲', text: 'Posts réguliers sur Facebook & Instagram' },
                    { icon: '📍', text: 'Visibilité Google My Business & référencement local' },
                    { icon: '💼', text: 'Contenu LinkedIn adapté à votre secteur' },
                    { icon: '📊', text: 'Statistiques et analyse de concurrence' },
                  ].map(({ icon, text }) => (
                    <div key={text} className="flex items-center gap-3 px-3 py-2 bg-gray-50 rounded-xl text-sm text-gray-700">
                      <span className="text-lg shrink-0">{icon}</span>
                      <span>{text}</span>
                    </div>
                  ))}
                </div>
                <div className="bg-emerald-50 border border-emerald-200 rounded-xl px-4 py-3 mb-4 text-center">
                  <p className="text-emerald-800 font-semibold text-sm">✅ 30 jours gratuits — aucun prélèvement immédiat</p>
                  <p className="text-emerald-600 text-xs mt-0.5">Annulable à tout moment.</p>
                </div>
                <button
                  onClick={handleSubscribe}
                  disabled={billingLoading}
                  className="w-full py-3.5 bg-gradient-to-r from-violet-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-violet-700 hover:to-indigo-700 disabled:opacity-60 transition-all shadow-md text-sm"
                >
                  {billingLoading ? 'Redirection...' : 'Démarrer mon mois gratuit →'}
                </button>
                <button onClick={logout} className="mt-3 w-full text-xs text-gray-400 hover:text-gray-500 transition-colors">
                  Se déconnecter
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Top bar */}
        <header className="flex items-center justify-between h-14 px-4 md:px-6 bg-white border-b border-gray-100 shrink-0">
          <div className="flex items-center gap-3">
            {/* Hamburger — mobile only */}
            <button
              onClick={() => setSidebarOpen(true)}
              className="md:hidden p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 transition-colors"
              aria-label="Ouvrir le menu"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <h1 className="text-base font-semibold text-gray-900">{pageTitles[activeTab]}</h1>
            <span className="hidden sm:inline text-[11px] font-semibold text-violet-700 bg-violet-50 border border-violet-200 px-2 py-0.5 rounded-full capitalize">
              {user?.subscription_tier || 'Starter'}
            </span>
          </div>
          <div className="flex items-center gap-3">
            {user?.activite && (
              <span className="hidden sm:block text-xs text-gray-400 bg-gray-50 border border-gray-200 px-3 py-1 rounded-full">
                {user.activite}
              </span>
            )}
            <div className="flex items-center gap-2">
              <div className="hidden sm:block text-right">
                <p className="text-[13px] font-medium text-gray-800 leading-tight">{user?.username}</p>
              </div>
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-emerald-400 to-teal-500 flex items-center justify-center text-white text-xs font-bold">
                {initials}
              </div>
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 overflow-y-auto">
          <div className={activeTab === 'cadastre' || activeTab === 'estimation' || activeTab === 'ventes' ? 'w-full px-6 py-6' : 'max-w-6xl mx-auto px-6 py-6'}>

            {activeTab === 'overview' && <AnalyticsDashboard />}

            {activeTab === 'notifications' && <NotificationsPage />}
            {activeTab === 'bilan' && <BilanPage />}
            {activeTab === 'parrainage' && <ParrainagePage />}
            {activeTab === 'fiche-google' && <FicheGooglePage />}
            {activeTab === 'videos' && <VideosPage />}

            {activeTab === 'social' && <SocialNetworksPage />}

{activeTab === 'calendar' && <CalendarPage />}

            {activeTab === 'reviews' && <ReviewsPage />}

            {activeTab === 'inbox' && <InboxPage />}
            {/* Secrétaire IA et Agent Mail IA : en stand-by, non accessibles pour le moment. */}

            {activeTab === 'intelligence' && <IntelligencePage />}

            {activeTab === 'cadastre' && isImmo && <CadastrePage />}

            {activeTab === 'estimation' && isImmo && <EstimationPage />}
            {activeTab === 'ventes' && isImmo && <VentesPage />}

            {activeTab === 'prospects' && isImmo && <ProspectsPage />}


            {activeTab === 'profile' && (
              <div className="space-y-6 max-w-3xl">

                {/* Sous-menu */}
                <div className="flex gap-1 bg-gray-100 p-1 rounded-xl w-fit">
                  {(['profil', 'abonnement'] as const).map(tab => (
                    <button
                      key={tab}
                      onClick={() => setProfileTab(tab)}
                      className={`px-5 py-2 rounded-lg text-sm font-medium transition-all capitalize ${
                        profileTab === tab ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'
                      }`}
                    >
                      {tab === 'profil' ? '👤 Profil' : '💳 Abonnement'}
                    </button>
                  ))}
                </div>

                {profileTab === 'abonnement' && <BillingSection />}

                {profileTab === 'profil' && <>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
                  <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">Informations</h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {[
                      { label: 'Nom complet',          value: user?.username,        type: 'text' },
                      { label: 'Email',                 value: user?.email,           type: 'email' },
                      { label: 'Entreprise / Enseigne', value: user?.nom_entreprise,  type: 'text' },
                      { label: 'Activité',              value: user?.activite,        type: 'text' },
                      { label: 'Ville',                 value: user?.ville,           type: 'text' },
                      { label: 'Site web',              value: user?.site_web,        type: 'url' },
                    ].map(({ label, value, type }) => (
                      <div key={label}>
                        <label className="block text-xs font-medium text-gray-500 mb-1">{label}</label>
                        <input type={type} value={value || ''} disabled
                          className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg bg-gray-50 text-gray-700" />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <h2 className="text-sm font-semibold text-gray-900">Profil IA extrait du site web</h2>
                      <p className="text-xs text-gray-400 mt-0.5">Utilisé par Gemini pour personnaliser vos posts</p>
                    </div>
                    {user?.site_web && (
                      <button onClick={handleAnalyzeWebsite} disabled={analyzingWebsite}
                        className="flex items-center gap-2 bg-violet-600 text-white text-sm px-4 py-2 rounded-lg hover:bg-violet-700 disabled:opacity-60 transition-colors shrink-0">
                        {analyzingWebsite
                          ? <><span className="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full" /> Analyse...</>
                          : <><Icon.Search /> Analyser</>}
                      </button>
                    )}
                  </div>
                  {analyzeMsg && (
                    <p className={`text-sm mb-4 px-3 py-2 rounded-lg ${analyzeMsg.startsWith('✅') ? 'bg-emerald-50 text-emerald-800 border border-emerald-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
                      {analyzeMsg}
                    </p>
                  )}
                  {(descriptionActivite || user?.description_activite) ? (
                    <pre className="text-xs text-gray-700 whitespace-pre-wrap font-mono bg-gray-50 border border-gray-200 rounded-xl p-4 max-h-64 overflow-y-auto">
                      {descriptionActivite || user?.description_activite}
                    </pre>
                  ) : (
                    <div className="text-center py-8 text-gray-400 border border-dashed border-gray-200 rounded-xl">
                      <p className="text-sm">
                        {user?.site_web ? 'Cliquez sur "Analyser" pour générer un profil détaillé.' : 'Renseignez votre site web pour activer l\'analyse IA.'}
                      </p>
                    </div>
                  )}
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
                  <h2 className="text-sm font-semibold text-gray-900 mb-1">Objectifs & angles de contenu</h2>
                  <p className="text-xs text-gray-400 mb-4">Personnalisent vos prochains posts IA</p>
                  {loadingObjectives ? <div className="text-sm text-gray-400">Chargement...</div> : <ObjectivesSelector value={objectivesData} onChange={saveObjectives} />}
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
                  <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">Abonnement</h2>

                  {paymentMsg === 'success' && (
                    <div className="mb-4 px-4 py-3 bg-emerald-50 border border-emerald-200 rounded-xl text-sm text-emerald-800">
                      ✅ Abonnement activé ! Votre mois d'essai gratuit commence maintenant.
                    </div>
                  )}
                  {paymentMsg === 'cancel' && (
                    <div className="mb-4 px-4 py-3 bg-amber-50 border border-amber-200 rounded-xl text-sm text-amber-800">
                      Paiement annulé. Vous pouvez vous abonner à tout moment.
                    </div>
                  )}

                  {/* Abonnement actif (Stripe) */}
                  {user?.subscription_status === 'active' && (
                    <div className="flex items-center justify-between p-4 bg-gradient-to-r from-violet-50 to-indigo-50 border border-violet-200 rounded-xl">
                      <div>
                        <p className="font-semibold text-violet-900">✅ Abonnement actif</p>
                        <p className="text-sm text-violet-600 mt-0.5">Gérez ou annulez depuis le portail Stripe</p>
                      </div>
                      <button onClick={handleManageBilling} disabled={billingLoading}
                        className="bg-violet-600 text-white text-sm px-4 py-2 rounded-lg hover:bg-violet-700 disabled:opacity-60 transition-colors">
                        {billingLoading ? '...' : 'Gérer'}
                      </button>
                    </div>
                  )}

                  {/* Période d'essai gratuite (pas encore abonné Stripe) */}
                  {user?.subscription_status === 'trial' && (
                    <div className="flex items-center justify-between p-4 bg-gradient-to-r from-violet-50 to-indigo-50 border border-violet-200 rounded-xl">
                      <div>
                        <p className="font-semibold text-violet-900">🎁 Période d'essai gratuite</p>
                        <p className="text-sm text-violet-600 mt-0.5">1 mois offert — aucun prélèvement pendant l'essai</p>
                      </div>
                      <button onClick={handleSubscribe} disabled={billingLoading}
                        className="bg-violet-600 text-white text-sm px-4 py-2 rounded-lg hover:bg-violet-700 disabled:opacity-60 transition-colors">
                        {billingLoading ? '...' : 'S\'abonner'}
                      </button>
                    </div>
                  )}

                  {/* Paiement en retard */}
                  {user?.subscription_status === 'past_due' && (
                    <div className="flex items-center justify-between p-4 bg-red-50 border border-red-200 rounded-xl">
                      <div>
                        <p className="font-semibold text-red-800">⚠️ Paiement en échec</p>
                        <p className="text-sm text-red-600 mt-0.5">Mettez à jour votre moyen de paiement pour continuer.</p>
                      </div>
                      <button
                        onClick={handleManageBilling}
                        disabled={billingLoading}
                        className="bg-red-600 text-white text-sm px-4 py-2 rounded-lg hover:bg-red-700 disabled:opacity-60 transition-colors"
                      >
                        {billingLoading ? '...' : 'Mettre à jour'}
                      </button>
                    </div>
                  )}

                  {/* Inactif */}
                  {user?.subscription_status === 'inactive' && (
                    <div className="flex items-center justify-between p-4 bg-gray-50 border border-gray-200 rounded-xl">
                      <div>
                        <p className="font-semibold text-gray-800">Aucun abonnement actif</p>
                        <p className="text-sm text-gray-500 mt-0.5">Commencez avec 1 mois gratuit, sans engagement.</p>
                      </div>
                      <button
                        onClick={handleSubscribe}
                        disabled={billingLoading}
                        className="bg-violet-600 text-white text-sm px-4 py-2 rounded-lg hover:bg-violet-700 disabled:opacity-60 transition-colors"
                      >
                        {billingLoading ? '...' : 'Commencer gratuitement'}
                      </button>
                    </div>
                  )}
                </div>

                </>}

              </div>
            )}
          </div>
        </main>
      </div>

      {showCreatePost && (
        <CreatePostModal
          onClose={() => setShowCreatePost(false)}
          onPostCreated={() => setActiveTab('calendar')}
        />
      )}
    </div>
  );
};

export default Dashboard;
